import { useState } from "react";
import Image from "next/legacy/image";
import styles from "./StockHeaderLogo.module.scss";
import { getMissingLogo } from "@/controllers/stock";
import { useNoBackgroundLogos } from "src/hooks/useNoBackgroundLogos";
import { useCompanyLogo, useLogosConfig } from "@/lib/logos";

const StockHeaderLogo = ({ stock, theme }) => {
    const logosCfg = useLogosConfig(); // re-render when web flips the logo source or rotates the token
    const { logoNoBackground } = useNoBackgroundLogos();
    const logo = useCompanyLogo(stock, "rect", { onMissing: () => stock.security_id && getMissingLogo(stock.security_id) });
    const [blankImg, setBlankImg] = useState<boolean>(false);

    const handleImgLoad = (event) => {
        const width = event.target.naturalWidth;
        setBlankImg(width <= 1 ? true : false);
    };

    return (
        <div
            className={styles.StockLogo}
            style={{
                backgroundColor: logo.plate ?? (logosCfg.source === "edge" ? "transparent" : theme === "dark" && !blankImg && !logoNoBackground(stock.security_id) ? "#c0c0c0" : "transparent"),
                borderRadius: "4px",
                paddingTop: "1px",
                paddingBottom: "1px",
            }}
        >
            {!logo.failed && (
                <Image
                    unoptimized
                    src={logo.src}
                    alt={`logo`}
                    layout="fill"
                    objectFit="contain"
                    onError={logo.onError}
                    onLoad={(event) => {
                        logo.onLoad(event);
                        handleImgLoad(event);
                    }}
                />
            )}
        </div>
    );
};

export default StockHeaderLogo;
